import axios from "axios";

// Create the Axios instance
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  // baseURL:"http://localhost:5003/api"
});

// This function will run before every request is sent.
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      // If a token exists, add it to the Authorization header
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // Handle request errors
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    // If the response is successful, just return it
    return response;
  },
  (error) => {
    // Check if the error is a 401 Unauthorized
    if (error.response && error.response.status === 401) {
      // Clear the invalid token from storage
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      // Redirect to the login page
      window.location.href = "/login";
    }
    // Return any other errors to be handled by React Query's onError
    return Promise.reject(error);
  }
);

export const login = async ({ email, password }) => {
  const response = await api.post("/auth/login", { email, password });
  return response.data.data;
};

export const createEmployee = async (data) => {
  // ✅ Assume date fields already converted to epoch in onSubmit
  const payload = {
    ...data,
    bankDetails: {
      branch: data.bankDetails?.branch || "",
      bankName: data.bankDetails?.bankName || "",
      accountNo: data.bankDetails?.accountNo || "",
      accountType: data.bankDetails?.accountType || "",
      ifscCode: data.bankDetails?.ifscCode || "",
    },
  };

  const response = await api.post("/employees", payload, {
    headers: { "Content-Type": "application/json" },
  });

  return response.data;
};



export const createBulkTasks = async (payload) => {
  // payload can be: { tasks: [...] } or { tasks: [...], employeeProfileId: "..." }
  const { data } = await api.post("/tasks/bulk", payload); // ✅ if backend expects /tasks/bulk
  return data;
};


export const verifyMe = async () => {
  const response = await api.get("/auth/me");
  return response.data.data; // Return the user object
};

export default api;
